import type { MasteryMapListItem } from '@ts-mastery-map/interfaces'

import { useDisciplineStore } from '@stores/discipline'
import { useMasteryMapStore } from '@stores/mastery-map'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

let latestRequestId = 0

interface MasteryMapListApiReturn {
  fetchMasteryMaps: () => Promise<void>
}

export const useMasteryMapListApi = (): MasteryMapListApiReturn => {
  const { $axios } = useNuxtApp()
  const disciplineStore = useDisciplineStore()
  const masteryMapStore = useMasteryMapStore()

  const fetchMasteryMaps = async (): Promise<void> => {
    const disciplineId = disciplineStore.activeDiscipline?.id

    if (!disciplineId) {
      console.warn('missing disciplineId for mastery-map/mastery-map-list.hook.ts')

      return
    }

    const url = useCsRoutes('disciplines.mastery-maps', {
      '[discipline_id]': disciplineId,
    })

    if (!url) {
      console.warn('missing url for mastery-map/mastery-map-list.hook.ts')

      return
    }

    latestRequestId += 1
    const requestId = latestRequestId
    const isSuperseded = (): boolean => requestId !== latestRequestId

    try {
      masteryMapStore.setListLoading(true)
      const { data } = await $axios.get(url)

      if (isSuperseded()) return

      if (data?.success) {
        masteryMapStore.setList((data?.data ?? []) as MasteryMapListItem[])
      }
    } catch (err: unknown) {
      console.error('unable to retrieve mastery-map/mastery-map-list.hook.ts:', err)

      if (isSuperseded()) return

      masteryMapStore.setList([])
    } finally {
      if (!isSuperseded()) {
        masteryMapStore.setListLoading(false)
      }
    }
  }

  return { fetchMasteryMaps }
}
